import React from 'react';

function About() {
  return (
    <>
      <div style={{marginTop:'3rem',width:'100%',height:'10px'}} className="about-scroll" id="about-scroll"></div>

      <div className="container about">
        <div className="row">
          <div className="col-md-6 text-center">
            <img 
              alt="Lunar Electric - Professional Solar Panel Installation Company in India" 
              src="./img/img1.png" 
              className="img-fluid"
              style={{
                maxWidth: '300px',
                maxHeight: '200px',
                objectFit: 'contain',
                margin: '0 auto',
                display: 'block'
              }}
            />
          </div>
          <div className="col-md-6">
            <h2 className="main-title about-h2">ABOUT</h2>
            <p className="main-p">
              Lunar Electric is a comprehensive renewable energy company, focused on providing renewable energy solutions to retail and commercial and industrial (C&I) customers. From 3kw residential customers to 10MW industrial customers or even annual maintenance contracts (AMC), we cover them all.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
export default About;
